<div class="inline-block" data-test-id="ribbon">
	<div
		class="rounded-r-xs ribbon p-1.5 text-xs font-semibold uppercase !leading-none tracking-wider text-dark-primary md:p-2 md:text-sm"
	>
		{{ ribbonText }}
	</div>
	<div
		class="ribbon-fold size-0 border-b-[5px] border-r-[8px] border-solid"
	></div>
</div>
